module.exports = __webpack_public_path__ + "media/images/lp_modal-image_price-fd3efb0cfebaa4b7419bf83a78671b21.webp";